import React from 'react';
import { InstagramIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { instagramTiles } from '../data/gallery';
export function InstagramFeed() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white py-20 sm:py-24" data-id="element-228" data-mp="22pk8p45vnvxd">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-229" data-mp="22qv8yu046ljq">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-230" data-mp="2zgcpk40mxs07">
          <div data-id="element-231" data-mp="2ugzs6pc512jd">
            <p className="text-sm font-semibold text-brand-blue" data-id="element-232" data-mp="2ughyo0gv12f5">{t.instagram.kicker}</p>
            <h2 className="mt-2 font-display text-3xl font-bold tracking-tight text-navy sm:text-4xl" data-id="element-233" data-mp="2qemyx0ekux3h">
              {t.instagram.title}
            </h2>
            <p className="mt-3 max-w-xl text-base text-ink/70" data-id="element-234" data-mp="2lfs758ymty78">{t.instagram.subtitle}</p>
            <dl className="mt-5 flex gap-8" data-id="element-235" data-mp="1f1kgdzsx3xgo">
              {[{
              value: business.instagramStats.posts,
              label: t.instagram.posts
            }, {
              value: business.instagramStats.followers,
              label: t.instagram.followers
            }, {
              value: business.instagramStats.following,
              label: t.instagram.following
            }].map(stat => <div key={stat.label} data-id="element-236" data-mp="2ov242fvjo9uk">
                  <dt className="text-xs font-medium text-ink/60" data-id="element-237" data-mp="2otzfielp2jht">{stat.label}</dt>
                  <dd className="font-display text-xl font-extrabold text-navy" data-id="element-238" data-mp="2ts0uoog01yo0">{stat.value}</dd>
                </div>)}
            </dl>
          </div>
          <a href={business.instagramHref} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 self-start rounded-lg bg-navy px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 hover:bg-navy-700" data-id="element-239" data-mp="2jvpjk1s5bev5">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="1w6mrdzzvy3me" />
            {t.instagram.cta}
          </a>
        </div>

        <ul className="mt-10 grid grid-cols-3 gap-2 sm:gap-3 lg:grid-cols-9" data-id="element-241" data-mp="21455e4srf919">
          {instagramTiles.map((src, index) => <li key={src + index} data-id="element-242" data-mp="6qat1xk34yei" data-mpi={index}>
              <a href={business.instagramHref} target="_blank" rel="noreferrer" className="block overflow-hidden rounded-lg" data-id="element-243" data-mp="1xhkszper7xo">
                <img src={src} alt={`${t.instagram.tileAlt} ${index + 1}`} loading="lazy" className="aspect-square w-full object-cover transition-transform duration-200 hover:scale-[1.04]" data-id="element-244" data-mp="3p3ibl6zlew4c" />
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}